import { IMutationProps } from '../../../interfaces/ui';
import {
  displayErrorNotification,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { deleteCaseConversationSchedule } from '../../conversationSchedules';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';

type useDeleteCaseConversationSchedulesParams = {
  organizationId: string;
  caseId: string;
};

const useDeleteCaseConversationSchedule = (
  params: useDeleteCaseConversationSchedulesParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (id: string) => {
      await deleteCaseConversationSchedule(
        params.organizationId,
        params.caseId,
        id
      );
    },
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.ConversationSchedules.DeleteCaseConversationSchedule.success'
      );

      if (options.successFb) options.successFb();
    },
    onErrorArray: () => {
      displayErrorNotification(
        'Api.Mutations.ConversationSchedules.DeleteCaseConversationSchedule.failure'
      );

      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};

export default useDeleteCaseConversationSchedule;
